import React, { useState } from 'react'

import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { Nullable } from '@application/Types/Opt'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Html } from '@src/Application/Interfaces/Atoms/Html'
import { FreightResroucesCategoryType } from '@src/Application/Types/ComponentTypes'
import { getDOMIdFromString } from '@src/Infrastructure/Url/getDomIdFromString'

import { Button, CategoryDescription, CategoryTitle, Link, Title, Wrapper } from './FreightResourcesListItem.styled'

const MAX_ELEMENTS = 20

type GlobalFreightGuideListItemType = {
    title: Nullable<string>
    category: FreightResroucesCategoryType
}

export const FreightResourcesListItem = (props: GlobalFreightGuideListItemType): JSX.Element => {
    const { title, category } = props

    const { t } = useTranslation()

    const [expanded, setExpanded] = useState(false)

    const showLink = category.items.length > MAX_ELEMENTS

    const visibleItems = expanded ? category.items : category.items.slice(0, MAX_ELEMENTS)

    return (
        <Wrapper>
            {title && <Title>{title}</Title>}
            <CategoryTitle id={getDOMIdFromString(category.title)}>{category.title}</CategoryTitle>
            {category.description && (
                <CategoryDescription>
                    <Html content={category.description.data.childMarkdownRemark.html as string} />
                </CategoryDescription>
            )}
            <Grid container rowSpacing={2} columnSpacing={3}>
                {visibleItems.map((article) => {
                    return (
                        <Grid item xs={12} sm={6} md={3} key={`${category.title}-${article.title}`}>
                            <Link to={article.pageUrl}>{article.title}</Link>
                        </Grid>
                    )
                })}
                {showLink && (
                    <Grid item xs={12} spacingTop={4} spacingBottom={0} textAlign="center">
                        <Button
                            colorStyle="secondary"
                            onClick={() => setExpanded(!expanded)}
                            data-testid="learn-more-button"
                        >
                            {expanded ? t('showLess') : t('viewAll')}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Wrapper>
    )
}
